import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("cs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default http;

export const fetchContent = () => http.get("/public/content").then((r) => r.data);
export const fetchTestimonials = () => http.get("/public/testimonials").then((r) => r.data);
export const fetchAvailability = () => http.get("/public/availability").then((r) => r.data);
export const fetchBookedSlots = (date) => http.get(`/public/bookings/slots?date=${date}`).then((r) => r.data);
export const createBooking = (body) => http.post("/bookings", body).then((r) => r.data);
export const createNote = (body) => http.post("/notes", body).then((r) => r.data);
export const login = (body) => http.post("/auth/login", body).then((r) => r.data);
export const adminMe = () => http.get("/admin/me").then((r) => r.data);
export const fetchAdminNotes = () => http.get("/admin/notes").then((r) => r.data);
export const approveNote = (id) => http.post(`/admin/notes/${id}/approve`).then((r) => r.data);
export const deleteNote = (id) => http.delete(`/admin/notes/${id}`).then((r) => r.data);
export const fetchAdminBookings = () => http.get("/admin/bookings").then((r) => r.data);
export const cancelBooking = (id) => http.post(`/admin/bookings/${id}/cancel`).then((r) => r.data);
export const gcalStatus = () => http.get("/admin/gcal/status").then((r) => r.data);
export const gcalConnect = () => http.get("/admin/gcal/connect").then((r) => r.data);
export const gcalDisconnect = () => http.post("/admin/gcal/disconnect").then((r) => r.data);
export const fetchAnalytics = () => http.get("/admin/analytics").then((r) => r.data);
export const saveAvailability = (body) => http.put("/admin/availability", body).then((r) => r.data);
export const saveContent = (body) => http.put("/admin/content", body).then((r) => r.data);
export const uploadFile = (file, kind) => {
  const fd = new FormData();
  fd.append("file", file);
  return http.post(`/admin/upload?kind=${kind}`, fd).then((r) => r.data);
};
